import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import styles from './AdminLoginSSO.module.scss'

export const AdminLoginSSO = () => {
  const signIn = () => {
    KeycloakAdminService.doLogin()
  }

  return (
    <div className={styles['container']}>
      <div className={styles['sign-in']}>
        <div className={styles['text']}>Sign in to the Nomination Module</div>
        <NVButton classes={{ container: styles['button'] }} type='submit' text={'Continue'} onClick={() => signIn()} />
      </div>
    </div>
  )
}
